<div class="row justify-content-center">
  <div class="col-lg-12">
    <div class="card mt-2" *ngFor="let job of jobList">
      <div class="card-body">
        <div class="row">
          <div class="col-md-2" style="    display: flex;
    flex-wrap: nowrap;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;">
            <img *ngIf="job.getCompany()['logo']" src="{{baseURL +job.getCompany()['logo']}}"
              style="width: 80%; height: 50%;" alt="">
            <img *ngIf="!job.getCompany()['logo']" src="assets/img/default-logo.svg" style="width: 80%; height: 50%;"
              alt="">
          </div>
          <div class="col-md-7">
            <div class="company" style="left: 0;">
              <h4 class="entreprise-name"><i class="fa fa-briefcase" aria-hidden="true"></i> {{
                job.getCompany()['acronym'] }} <span *ngIf="typeInterface == 'entreprise'">
                  -
                  {{ job.getReference() }}</span></h4>
            </div>

            <h2 style="text-transform:uppercase;" *ngIf="!typeUser " class="list-offer-title"><a
                [routerLink]="['/offres-emploi', job.getId()]" class="list-offer-title">{{
                functionsService.wordWrap(job.getLibelle(), 50) }}</a></h2>

            <a style="text-transform:uppercase;" *ngIf="(typeInterface == 'candidat' && typeUser == 'candidat')"
              [routerLink]="['/offres-emploi', job.getId()]" class="list-offer-title">{{
              functionsService.wordWrap(job.getLibelle(), 50) }}</a>

            <div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center;">
              <h5 style="font-size: 15px !important; margin-right: 20px; "><i class="fa fa-map-marker"
                  aria-hidden="true"></i> {{ job.getCity() }}, {{
                job.getCountry() }}</h5>
              <h6 style="font-size: 15px !important; margin-right: 20px; "><i class="fa fa-clock-o"
                  aria-hidden="true"></i> {{ job.getTypeJob() }}</h6>
              <h6 style="font-size: 15px !important; "><i class="fa fa-level-up" style=" margin-right: 5px; "
                  aria-hidden="true"></i> <span *ngIf="(job.getJobLevel()==1)">Collecte </span>
                <span *ngIf="(job.getJobLevel()==2)">Pré selections</span>
                <span *ngIf="(job.getJobLevel()==3)">Tests </span>
                <span *ngIf="(job.getJobLevel()==4)">Entretiens</span>
                <span *ngIf="(job.getJobLevel()==5)">Dépôt de rapport</span>
                <span *ngIf="(job.getJobLevel()==6)">Cloture</span>
              </h6>
            </div>

          </div>
          <div class="col-md-3" style="    display: flex; flex-wrap: nowrap; flex-direction: row-reverse;">
            <div style="" *ngIf="!(typeUser )">
              <span style="font-weight: bold;">Date limite de dépôt: </span>
              <span class="badge badge-danger" *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                job.getExpirationDate()
                }}</span>
              <span class="badge badge-success" *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                job.getExpirationDate()
                }}</span> <br>


              <div class="address d-flex mt-4">
                <a style="font-weight: bold;" [routerLink]="['/offres-emploi', job.getId()]">
                  <span class="mr-2 btn btn-success a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                    title="Détails">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-display" viewBox="0 0 16 16">
                      <path
                        d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z" />
                    </svg>
                  </span></a>

                <span class="mr-2 btn btn-warning a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                  title="Partager" style="height: 30px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share"
                    viewBox="0 0 16 16">
                    <path
                      d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                  </svg>
                </span>
                <span class="mr-2 btn btn-danger a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                  title="Sauvegarder" style="height: 30px;" (click)="addJobInBackup(job.getId())">

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save"
                    viewBox="0 0 16 16">
                    <path
                      d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                  </svg>
                </span>

                <a class="mt-2" [routerLink]="['/postuler', job.getId()]" style="margin-top: 0px !important;">
                  <span class="mr-2 btn btn-primary a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                    title="Postuler"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-send" viewBox="0 0 16 16">
                      <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                    </svg></span>
                </a>
              </div>

            </div>

            <div style="margin-left: 0px;" *ngIf="(typeInterface == 'candidat' && typeUser == 'candidat')">
              <span style="font-weight: bold;">Date limite de dépôt: </span>
              <span class="badge badge-danger" *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                job.getExpirationDate()
                }}</span>
              <span class="badge badge-success" *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                job.getExpirationDate()
                }}</span> <br>


              <div class="address d-flex mt-4">
                <a style="font-weight: bold;" [routerLink]="['/offres-emploi', job.getId()]">
                  <span class="mr-2 btn btn-success a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                    title="Détails">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-display" viewBox="0 0 16 16">
                      <path
                        d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z" />
                    </svg>
                  </span></a>

                <span class="mr-2 btn btn-warning a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                  title="Partager" style="height: 30px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share"
                    viewBox="0 0 16 16">
                    <path
                      d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
                  </svg>
                </span>



                <span class="mr-2 btn btn-danger a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                  title="Sauvegarder" style="height: 30px;" (click)="addJobInBackup(job.getId())">

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-save"
                    viewBox="0 0 16 16">
                    <path
                      d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                  </svg>
                </span>

                <a class="mt-2" [routerLink]="['/postuler', job.getId()]" style="margin-top: 0px !important;">
                  <span class="mr-2 btn btn-primary a-btn-slide-text" data-toggle="tooltip" data-placement="top"
                    title="Postuler"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-send" viewBox="0 0 16 16">
                      <path
                        d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z" />
                    </svg></span>
                </a>
              </div>
            </div>
            <div style="margin-left: 0px;" *ngIf="typeInterface == 'entreprise' && typeUser == 'entreprise'">
              <div class="address mt-2">
                <span class="badge badge-primary" *ngIf="job.getStatus() == 'En cours'">En cours d'édition</span>
                <span class="badge badge-warning" *ngIf="job.getStatus() == 'En attente de validation'">En attente de
                  validation</span>
                <span class="badge badge-success" *ngIf="job.getStatus() == 'Validé'">Offre publiée</span>
                Expire le
                <span class="badge badge-danger" *ngIf="jobIsExpired(job.getExpirationDate()) == true">{{
                  job.getExpirationDate() }}</span>
                <span class="badge badge-success" *ngIf="jobIsExpired(job.getExpirationDate()) == false">{{
                  job.getExpirationDate() }}</span>
              </div>
              <div class="mb-4">
                <button class="mr-3 btn btn-primary mt-2" (click)="editJob(job)">Détails</button>
                <button (click)="getCandidatesApplyJob(job)" class="mr-3 mt-2 btn btn-danger "
                  style="border: 0; color: white">Candidats<span class="badge badge-danger badge-position"
                    style="display: none;">4</span></button>
                <button class="mr-3 mt-2 btn " style="background-color: #dc3545; color: white;"
                  (click)="deleteJob(job)">Supprimer</button>
              </div>
            </div>
            <div style="margin-left: 0px;" *ngIf="typeInterface == 'admin'">
              <div class="address mt-2">
                <span class="badge badge-primary" *ngIf="job.getStatus() == 'En cours'">En cours d'édition</span>
                <span class="badge badge-warning" *ngIf="job.getStatus() == 'En attente de validation'">En attente de
                  validation</span>
                <span class="badge badge-success" *ngIf="job.getStatus() == 'Validé'">Offre publiée</span>
                Expire le {{ job.getExpirationDate() }}
              </div>
              <div class="mb-4">
                <button class="mr-3 mt-2 btn btn-primary" (click)="editJob(job)">Détails</button>
                <button (click)="getCandidatesApplyJob(job)" class="mr-3 mt-2 btn bg-danger"
                  style="border: 0; color: white">Candidats<span class="badge badge-danger badge-position"
                    style="display: none;">4</span></button>
                <button class="mr-3 btn btn-danger" style="padding: 5px 15px; border-radius: 5px;"
                  (click)="deleteJob(job)">Supprimer</button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>


  <div class="col-lg-3"></div>
</div>